import React from "react";
import { Box, Modal, Text } from "@mantine/core";
import useStyles from "./style";
import ButtonComp from "../ButtonComponent/ButtonComp";
import { useSelector } from "react-redux";

const CustomModal = ({
  modalState,
  modalTopImg,
  modalTitle,
  modalText,
  modalTextOne,
  modalTextTwo,
  modalTextThree,
  closeModal,
  buttonTwoFunc,
  colorOne,
  colorTwo,
  btnTextOne,
  btnTextTwo,
  variantOne = "outline",
  variantTwo = "filled",
  noteType,
  setNoteType,
  isStaffWithoutApproval
}) => {
  // console.log("noteType inside custom modal :", noteType);
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state.profile);
  // console.log(
  //   "🚀 ~ ========================> profile?.user?.type:",
  //   profile
  // );
// const newAdminApproval = noteType?.adminApprovals?.find((item)=> item?.admin === profile?.user?.admin)?.status || noteType?.approvalRequired  

// console.log("🚀 ~ newAdminApproval:", newAdminApproval)

//   const isStaffWithoutApproval =
//     profile?.user?.type === "staff" && !newAdminApproval;

  const titleText =
    profile?.user?.type !== "staff"
      ? "Note Created Successfully"
      : isStaffWithoutApproval
      ? "Note Created Successfully"
      : modalTitle;

  const textOne =
    profile?.user?.type !== "staff"
      ? ""
      : isStaffWithoutApproval
      ? ""
      : modalTextOne;

  const textTwo =
    profile?.user?.type !== "staff"
      ? ""
      : isStaffWithoutApproval
      ? ""
      : modalTextTwo;
  const textThree =
    profile?.user?.type !== "staff"
      ? ""
      : isStaffWithoutApproval
      ? ""
      : modalTextThree;

  // const textTwo = isStaffWithoutApproval ? modalTextTwo : "";
  // const textThree = isStaffWithoutApproval ? modalTextThree : "";

  return (
    <>
      <Modal
        centered
        size="sm"
        zIndex={1000}
        radius={"md"}
        opened={modalState}
        overlayProps={{ blur: 3 }}
        onClose={() => closeModal()}
        transitionProps={{ duration: 200 }}
        withCloseButton={false}
      >
        <Box className={classes.modalElemsParent}>
          <img
            src={modalTopImg}
            alt="Warning Icon"
            className={classes.iconClass}
          />
          <Text c={"#262626"} mb={0} ff={"Inter"} fw={600} fs={"20px"}>
            {profile?.user?.type !== "staff" ? "Note Successfully Saved" : modalTitle}
          </Text>
          {modalText && (
            <Text c={"#737373"} ff={"Inter"} fw={400} fs={"16px"} ta={"center"}>
              <small>{modalText}</small>
            </Text>
          )}

          <Text
            c={"#737373"}
            mb={0}
            ff={"Inter"}
            fw={400}
            fs={"16px"}
            ta={"center"}
          >
            {profile?.user?.type === "staff" && modalTextOne && (
              <Box>
                <small>{modalTextOne}</small>
              </Box>
            )}
            {profile?.user?.type === "staff" && modalTextTwo && (
              <Box>
                <small>{modalTextTwo}</small>
              </Box>
            )}
            {profile?.user?.type === "staff" && modalTextThree && (
              <Box>
                <small>{modalTextThree}</small>
              </Box>
            )}
          </Text>
          <Box className={classes.btnsFlex}>
            {/* -----> Cancel & OK button <----- */}

            {btnTextOne && (
              <ButtonComp
                text={btnTextOne}
                onClick={() => {
                  closeModal(false);
                  setNoteType("");
                }}
                btnClass={classes.modalBtns}
                size="sm"
                c={"#000"}
                radius="md"
                color={colorOne}
                variant={variantOne}
              />
            )}

            {/* -----> Delete <----- */}

            {btnTextTwo && (
              <ButtonComp
                text={btnTextTwo}
                onClick={buttonTwoFunc}
                btnClass={classes.modalBtns}
                size="sm"
                radius="md"
                color={colorTwo}
                variant={variantTwo}
              />
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CustomModal;
